import React, { Component } from 'react';

// Tone -> palette. HEX values intentionally consistent across the tracking UI.
const COLOURS = {
    green: { bg: '#ECFDF5', fg: '#065F46', border: '#A7F3D0', dot: '#10B981' },
    amber: { bg: '#FFFBEB', fg: '#92400E', border: '#FCD34D', dot: '#F59E0B' },
    red:   { bg: '#FEF2F2', fg: '#991B1B', border: '#FECACA', dot: '#EF4444' },
    grey:  { bg: '#F1F5F9', fg: '#475569', border: '#E2E8F0', dot: '#94A3B8' }
};

const STATUS_TONE = {
    complete: 'green',
    passed: 'green',
    valid: 'green',
    received: 'green',
    incomplete: 'red',
    pending: 'red',
    missing: 'red',
    flagged: 'red',
    partial: 'amber',
    expired: 'amber'
};

const STATUS_LABEL = {
    complete: 'Complete',
    incomplete: 'Incomplete',
    passed: 'Passed',
    flagged: 'Flagged',
    pending: 'Pending',
    partial: 'Partial',
    valid: 'Valid',
    expired: 'Expired',
    received: 'Received',
    missing: 'Missing'
};

export default class StatusPill extends Component {
    render() {
        const { status, label, compact, count } = this.props;
        const tone = STATUS_TONE[status] || 'grey';
        const palette = COLOURS[tone];
        const text = label || STATUS_LABEL[status] || status || '-';
        return (
            <span
                className={`inline-flex items-center gap-1.5 rounded-full font-semibold whitespace-nowrap ${compact ? 'px-2 py-0.5' : 'px-2.5 py-1'}`}
                style={{
                    backgroundColor: palette.bg,
                    color: palette.fg,
                    border: `1px solid ${palette.border}`,
                    fontSize: compact ? 11 : 12,
                    lineHeight: 1.15,
                    letterSpacing: 0.1
                }}
            >
                <span
                    className="inline-block rounded-full shrink-0"
                    style={{ width: 7, height: 7, backgroundColor: palette.dot }}
                />
                <span>{text}</span>
                {typeof count === 'string' || typeof count === 'number' ? (
                    <span style={{ opacity: 0.7, fontWeight: 600 }}>· {count}</span>
                ) : null}
            </span>
        );
    }
}
